import { Box, useTheme } from '@mui/material'
import UserInfo from './UserInfo'
import Services from './Services'
import Offer from './Offer'
import { type IServicesList } from '../../utils/serviceList'

interface ISideBar {
  myServices?: IServicesList[]
}

const SideBar = ({ myServices }: ISideBar) => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('lg')]: {
          gap: '35px',
          padding: '32px 25px',
          width: '100%'
        },
        [theme.breakpoints.up('lg')]: {
          boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
          gap: '50px',
          padding: '50px 20px 0 30px',
          width: '391px'
        }
      }}>
        <UserInfo />
        <Services services={myServices}/>
        <Offer />
    </Box>
  )
}

export default SideBar
